import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function PublicRoute({ children }) {
    const { checkAuth } = useAuth();
    const [isChecking, setIsChecking] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const verify = async () => {
            const authenticated = await checkAuth();
            setIsAuthenticated(authenticated);
            setIsChecking(false);
        };

        verify();
    }, [checkAuth]);

    if (isChecking) {
        return <div className="min-h-screen flex items-center justify-center">
            <div className="text-lg">Caricamento...</div>
        </div>;
    }

    return isAuthenticated ? <Navigate to="/profilo" replace /> : children;
}